import { EMAIL_REGEX } from '@/utils/emailRegex';

import type { ChipValidator } from './ChipInput';

export const validateEmail: ChipValidator = (value) =>
  EMAIL_REGEX.test(value) ? 'valid' : { state: 'invalid', message: 'Not a valid email address' };

// Trim + lowercase so `Foo@Bar.com` and `foo@bar.com` dedupe to one chip.
export function normalizeEmail(value: string): string {
  return value.trim().toLowerCase();
}
